import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CarrierUserService,
  CarrierUserModel,
  CarrierUserRequest,
  CarrierUserEditRequest,
  CarrierUserListRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CarrierUserApiService {
  constructor(private apiService: CarrierUserService) {}

  public activateCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserActivate(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addCarrierUser(carrierId: string, body: CarrierUserRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserAdd(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.carrierUserDelete(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierUser(carrierId: string, userId: string, body: CarrierUserEditRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserEdit(carrierId, userId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserGet(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCarrierUsers(carrierId: string, body: CarrierUserListRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel[]> {
    return this.apiService.carrierUserList(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public resendCarrierUserInvitation(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserResendInvitation(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public suspendCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.carrierUserSuspend(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
